module.exports = __webpack_public_path__ + "Roboto-Medium.2741a14e49524efa6059.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Medium.woff2
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Medium.woff2
// module chunks = styles